import { OutOfCanvasUpdater } from "./OutOfCanvasUpdater";
export async function loadOutModesUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("outModes", (container) => new OutOfCanvasUpdater(container), refresh);
}
